import { useLocation } from "react-router-dom";
import SVGForPage from "../../components/SVGForPage";
import SideNav, { SideNavItem } from "../../components/SideNav";

type MenuItem = {
  id: number;
  title: string;
  url: string;
  icon: string;
};

const CGNavBar = () => {
  // Define our navbar
  const baseURL = `/compliance-guide/`;
  const menuItemsDef: MenuItem[] = [
    { id: 1, title: `Intro`, url: `${baseURL}intro`, icon: `bi-file-binary` },
    { id: 16, title: `AI Assistant`, url: `${baseURL}ai-assistant`, icon: `bi-robot` },
    { id: 2, title: `Guide`, url: `${baseURL}regulatory-guide`, icon: `bi-bank` },
    { id: 3, title: `Charts`, url: `${baseURL}regulatory-charts`, icon: `bi-bar-chart-line` },
    { id: 4, title: `Regulatory Watch`, url: `${baseURL}regulatory-watch`, icon: `bi-eye` },
    { id: 5, title: `DNC Maps`, url: `${baseURL}dnc-map`, icon: `bi-globe` },
    { id: 6, title: `Statutes`, url: `${baseURL}statutes`, icon: `bi-receipt` },
    { id: 9, title: `Consent Chart`, url: `${baseURL}consent-chart`, icon: `bi-diagram-2` },
    { id: 7, title: `FAQ`, url: `${baseURL}faq`, icon: `bi-patch-question` },
    { id: 8, title: `Compliance Wizard`, url: `${baseURL}compliance-wizard`, icon: `bi-magic` },
    { id: 10, title: `Glossary`, url: `${baseURL}glossary`, icon: `bi-book` },
    { id: 11, title: `Litigator Research`, url: `${baseURL}litigator-research`, icon: `bi-clipboard2-check` },
    { id: 15, title: `Litigator Scrub`, url: `${baseURL}litigator-scrub`, icon: `bi bi-table` },
    { id: 12, title: `FTC Complaint Search`, url: `${baseURL}ftc-complaint-search`, icon: `bi-search` },
    { id: 13, title: `Submit Litigator`, url: `${baseURL}submit-litigator`, icon: `bi-envelope` },
    { id: 14, title: `Other Tools`, url: `${baseURL}other-tools`, icon: `bi-tools` },
  ];

  // Set the active nav bar item based on the current URL
  const location = useLocation();

  // Map to the shared SideNav item shape (DRY — same nav component as the
  // TrustCall layout).
  const navItems: SideNavItem[] = menuItemsDef.map((item) => ({
    key: String(item.id),
    title: item.title,
    to: item.url,
    icon: <SVGForPage pageKeyword={item.url.split("/").pop()} />,
    active: location.pathname === item.url,
  }));

  return (
    <aside className="comp-guide-nav-container">
      {/* First navbar is overlay for narrower viewports */}
      <div
        aria-labelledby="compGuideMenuBtnLabel"
        className="offcanvas offcanvas-start"
        id="mobileCompGuideMenuNav"
      >
        <div className="offcanvas-header">
          <h5 className="offcanvas-title" id="compGuideMenuBtnLabel">
            Compliance Guide Menu
          </h5>
          <button
            aria-label="Close"
            className="btn-close"
            data-bs-dismiss="offcanvas"
            type="button"
          />
        </div>
        <span className="divider" />
        <nav className="offcanvas-body">
          <SideNav items={navItems} />
        </nav>
      </div>

      {/* Second navbar is for desktop viewports
          the d-none and d-lg-flex make it hide on smaller viewports */}
      <nav className="d-none d-lg-flex flex-column flex-shrink-0 p-2">
        <SideNav items={navItems} />
      </nav>
    </aside>
  );
};

export default CGNavBar;
